import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { CustomEventService } from '@shared/services/custom-event.service';
import { GlobalSettingsService } from '@shared/services/global-settings.service';

import ActionTypesEnum from '@shared/enums/action-constant.enum';

import { leagueColor, leaguePeriod } from '@shared/variables/league.variable';

import DateUtil from '@shared/utils/date.util';
import { validateFormGroup } from '@shared/utils/form.util';
import { UserService } from "@core/services/user.service";
import { PropertiesService } from "@core/services/properties.service";

@Component({
  selector: 'app-add-league-modal',
  templateUrl: './add-league-modal.component.html'
})
export class AddLeagueModalComponent implements OnInit {

  @Input() loading: boolean;
  @Input() mode: 'edit' | 'add';
  @Input() data;
  @Input() title: string;
  @Input() teams: Team.TeamModel[];
  @Input() users: User.UserModel[];

  addLeagueForm: FormGroup;
  dateTimeFormat: string;

  colors = leagueColor;
  periods = leaguePeriod;
  defaultReferee: any;

  constructor(private customEventService: CustomEventService,
              private fb: FormBuilder,
              private userService: UserService,
              public propertiesService: PropertiesService,
              private globalSettingsService: GlobalSettingsService) {

    this.dateTimeFormat = this.globalSettingsService.dateTimeFormat;
  }

  ngOnInit(): void {
    this.users = this.users.filter(item => item.enabled);
    this.defaultReferee = this.users.find(item => item.fullName === this.userService.activeUser.name + ' ' + this.userService.activeUser.surname);
    // this.notDeletedUser = this.users.filter(item => item.id.includes(this.data.referees));
    // this.data.referees = this.notDeletedUser.map(item => item.id);

    this.createForm();
  }

  createForm(): void {
    const {
      id = null,
      name = '',
      shortName = '',
      description = '',
      season = null,
      color = null,
      teams = [],
      referees = this.userService.activeUser.roles[0].name !== 'ROLE_SUPERUSER' ? [this.defaultReferee.id] : [],
      period = 'WEEKLY',
      from
    } = this.data;

    this.addLeagueForm = this.fb.group({
      id: [id, []],
      name: [name, [Validators.required]],
      shortName: [shortName, [Validators.required, Validators.maxLength(4)]],
      description: [description, []],
      season: [season, []],
      color: [color, [Validators.required]],
      teams: [teams, []],
      referees: [referees, [Validators.required]],
      period: [period, []],
      from: [from ? DateUtil.getMillisecondDate(from) : new Date(), []]
    });
  }

  submitForm(): void {
    validateFormGroup(this.addLeagueForm);

    if (this.addLeagueForm.invalid) {
      return;
    }

    const formData = this.addLeagueForm.value;

    formData.from = DateUtil.getTimestampInSeconds(formData.from);

    this.customEventService.announceEvent(this.mode === 'add' ? ActionTypesEnum.CREATE_LEAGUE : ActionTypesEnum.UPDATE_LEAGUE, formData);
  }

  resetForm(): void {
    this.createForm();
  }

  cancelForm(): void {
    this.customEventService.announceEvent(ActionTypesEnum.CLOSE_MODAL);
  }
}
